import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-site-about',
  templateUrl: './site-about.component.html',  
  styleUrls: ['./site-about.component.scss']
})
export class SiteAboutComponent implements OnInit {

  public BuildInfo: any;
  public _Loaded = false;
  
  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.LoadProfileData();
    }
  
    public LoadProfileData() {
      this.http.get('./../../../assets/site/site.toolchain.json')
          .subscribe(data => {
           this.BuildInfo  = data;
           //let iRowIndex = -1;
           //this.InterviewQuestions.QuestionSets.forEach(element => {
             //iRowIndex++;
             //element.state = 'show';
             //element.state = 'hide-odd';
             //if (iRowIndex % 2 === 0) {
              //element.state = 'hide-even';
             //}
           //});         
           //this.ProfileData.Profiles[this.ProfileIndex].state = 'show';
           this._Loaded = true;
           },
           error => {
             console.log('oops', error);
            }
          );
    }

}

